/**
 * Быстрые подсказки активного режима (US-10, §«Дизайн» — чипы с примерами
 * запросов). Клик по чипу отправляет его текст как реплику пользователя.
 */
import { ChevronRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import type { AssistantModeDef } from './modes';

interface SuggestionChipsProps {
  mode: AssistantModeDef;
  disabled: boolean;
  onPick: (text: string) => void;
}

export const SuggestionChips = ({
  mode,
  disabled,
  onPick,
}: SuggestionChipsProps) => {
  const { t } = useTranslation();
  const chips = Array.from({ length: mode.suggestions }, (_, index) =>
    t(`assistant.modes.${mode.id}.s${index + 1}`),
  );
  return (
    <div
      className="flex shrink-0 flex-wrap gap-2 border-b border-surface-border bg-surface px-4 pb-3"
      data-testid="assistant-suggestions"
    >
      {chips.map((chip) => (
        <button
          key={chip}
          type="button"
          disabled={disabled}
          onClick={() => onPick(chip)}
          className="flex items-center gap-1.5 rounded-full border border-brand-100 bg-surface px-3 py-1.5 text-xs text-brand-700 transition-colors hover:bg-brand-50 disabled:cursor-not-allowed disabled:opacity-50"
        >
          <ChevronRight className="size-3 text-text-faint" aria-hidden="true" />
          {chip}
        </button>
      ))}
    </div>
  );
};
